package com.appcreator.blueprint.core.properties

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonElement


@Serializable
data class UserDefinedComponent(
    val id: String,
    val name: String,
    val properties: Map<String, JsonElement>
)
